export default __webpack_public_path__ + "static/media/slide2.d624b449.jpg";